import { useSyncExternalStore } from 'react';
import { config } from './config';

/**
 * Store bahasa aktif (id/en), persist di localStorage, reaktif lewat
 * useSyncExternalStore. Ganti bahasa → semua komponen yg pakai useLang()
 * re-render & query re-fetch (karena lang jadi bagian queryKey).
 */
export type Lang = 'id' | 'en';

const KEY = 'quickplay.lang';
const listeners = new Set<() => void>();

function read(): Lang {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'id' || v === 'en') return v;
  } catch {
    // localStorage bisa throw (private mode) — fallback ke default.
  }
  return (config.defaultLang === 'en' ? 'en' : 'id') as Lang;
}

let current: Lang = read();

export function getLang(): Lang {
  return current;
}

export function setLang(next: Lang): void {
  if (next === current) return;
  current = next;
  try {
    localStorage.setItem(KEY, next);
  } catch {
    // abaikan — state in-memory tetap update.
  }
  for (const l of listeners) l();
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useLang(): Lang {
  return useSyncExternalStore(subscribe, getLang, getLang);
}
